import { Link } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Premium landing scaffold used by Community / Vrat / Enterprise pages.
 * Investor-viewable pages that clearly signal these are part of the platform.
 */
export default function PremiumLanding({ badge, title, tagline, description, capabilities, ctaLabel, testid }) {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16" data-testid={testid}>
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-[10px] uppercase tracking-widest mb-6">
        <Sparkles className="w-3 h-3" strokeWidth={2} /> {badge}
      </div>
      <h1 className="font-serif text-4xl md:text-6xl font-semibold tracking-tight leading-[1.02]">{title}</h1>
      <p className="text-lg md:text-xl text-muted-foreground mt-4 max-w-2xl">{tagline}</p>
      <p className="text-sm md:text-base text-foreground/80 mt-6 leading-relaxed max-w-2xl">{description}</p>

      <div className="grid md:grid-cols-2 gap-4 mt-10">
        {capabilities.map((c, i) => (
          <div key={i} className="p-5 rounded-2xl border border-border bg-card">
            <div className="overline mb-1">{c.label}</div>
            <div className="text-sm text-foreground/85 leading-snug">{c.detail}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 p-6 rounded-2xl border border-primary/30 bg-primary/[0.04] flex items-start gap-4">
        <Lock className="w-5 h-5 text-primary shrink-0 mt-0.5" strokeWidth={1.75} />
        <div className="flex-1">
          <div className="font-medium">Part of YUMO Premium</div>
          <div className="text-sm text-muted-foreground">Unlocked during your 2-day launch trial. Powered by the same YUMO Intelligence Engine.</div>
        </div>
        <Link to="/dashboard"><Button variant="outline" className="rounded-full">Back to Solo</Button></Link>
      </div>
    </div>
  );
}
